/**
 * ヒーロー画像パララックス（rejouice 風）。
 *
 * 対象: [data-hero-parallax] 要素内の <img>。
 * data-hero-parallax-speed = 画像がスクロールに対して動く割合（0〜1, 既定 0.5）。
 *
 * 仕組み:
 *   ヒーローは 100vh、画像は (100 + speed*100)vh の高さ（CSS 側で指定）。
 *   ヒーローが top:top → bottom:top へ抜ける間（スクロール量 = 100vh）に、
 *   画像を speed*100vh 上へ移動 → 通常スクロールの (speed) 倍速で動いて見える。
 *
 * Lenis とは gsap.ticker 経由で同期済み（lenis-init.js）。ScrollTrigger.update も接続済み。
 * PC（min-width:769px）のみ。prefers-reduced-motion では無効。
 */
(function () {
  var triggers = [];

  function build() {
    if (typeof window.gsap === 'undefined' || typeof window.ScrollTrigger === 'undefined') return false;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return true;

    window.gsap.registerPlugin(window.ScrollTrigger);

    var isDesktop = !window.matchMedia || window.matchMedia('(min-width: 769px)').matches;

    document.querySelectorAll('[data-hero-parallax]').forEach(function (el) {
      var img = el.querySelector('img');
      if (!img) return;

      // data-hero-parallax-speed = 画像の見かけスピード（0〜1, 1.0=通常スクロールと同じ, 小さいほど遅くラグ）
      var speed = parseFloat(el.getAttribute('data-hero-parallax-speed'));
      if (isNaN(speed)) speed = 0.7;

      // SP では視差なし（画像は通常表示）
      if (!isDesktop) return;

      // Rellax 型（中央基準・背景ラグ）:
      //   ラグ率 p = 1 - speed。要素がビューポートを横切るスクロール量 = 200vh。
      //   画像余白 extra = p*200[vh]（CSS の calc と一致）。画像高さ = 100 + extra。
      //   可動域(yPercent) X = extra/(100+extra)*100。
      //   進捗 0(要素が画面下)→1(要素が画面上) で yPercent を -X → 0 と動かす
      //   = 画像が下方向へラグ（スクロールより遅い＝背景的）。進捗0.5(要素が画面中央)で -X/2 = 画像センター。
      var p = 1 - speed;
      var extra = p * 200;
      var moveX = extra <= 0 ? 0 : (extra / (100 + extra)) * 100;
      var el2 = el.closest('.banner') || el;

      var tween = window.gsap.fromTo(
        img,
        { yPercent: -moveX },
        {
          yPercent: 0,
          ease: 'none',
          scrollTrigger: {
            // 要素の出入りに連動（Rellax と同じ中央基準）。
            // ヒーローはページ先頭にあるため、読み込み時点で進捗 ≒ 0.5（=画像センター）から始まり、
            // 最初のスクロールで即座に視差が動く。
            trigger: el2,
            start: 'top bottom',
            end: 'bottom top',
            scrub: true,
            invalidateOnRefresh: true,
          },
        }
      );
      if (tween.scrollTrigger) triggers.push(tween.scrollTrigger);
    });

    window.ScrollTrigger.refresh();
    return true;
  }

  function init() {
    if (build()) return;
    // GSAP/ScrollTrigger は defer 読み込み。まだ無ければ少し待つ。
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      if (build() || tries > 60) clearInterval(iv);
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
